/**
 * Supported languages
   en-CA
   en-GB
   fr-CA

 * @type {{locale: string}}
 */
var argv = require('minimist')(process.argv.slice(2));
var lang = argv.lang;


module.exports = {
  locale: lang !== undefined ? lang :  "en-GB"
};



//////////////////
// WEBPACK FOOTER
// ./config/lang.js
// module id = 518
// module chunks = 1